// 🔹 Mezcla datos del SII con los del Excel, sin sobrescribir con vacíos
export function mergeReceiverData(fromApi, fromExcel) {
  const merged = { ...fromApi }
  for (const key in fromExcel) {
    const val = fromExcel[key]
    if (val !== '' && val !== undefined && val !== null) {
      merged[key] = val
    }
  }
  return merged
}
